import { ProductProcessingMode } from 'cloud-shared-lib';
import { PriceListProductBazisElement } from './price-list-product-bazis-element.model';
import { PriceListProductElasticInfo } from './price-list-product-elastic-info.model';
import { PriceListProductUserProperty } from './price-list-product-user-property.model';

export enum TypeProductBazis {
  tpPiece,
  tpMoldings,
  tpSquare,
}

export enum ModeInstallationProduct {
  mipArbitrary,
  mipPlaceFloor,
  mipLevel,
}

export class PriceListProductBazis {
  id: number;
  name: string;
  article: string;
  measure: string;
  price: number;
  isNotSale: boolean;
  note: string;
  weight: number;
  width: number;
  height: number;
  length: number;
  typeProduct: TypeProductBazis;
  picturePath: string;
  priceSmeta: number;
  code1C: string;
  processingMode: ProductProcessingMode;

  typeId: number;
  modelId: number;

  isNotAddToOrder: boolean;
  maxDiscount: number;
  maxMarkup: number;

  elements: PriceListProductBazisElement[] = [];
  relatedProductList: number[] = [];
  userProperties: PriceListProductUserProperty[] = [];
  elastic: PriceListProductElasticInfo = new PriceListProductElasticInfo();
  imageList: string[] = [];
}
